import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'
import { installChunkReload } from '@/lib/chunkReload'

/* Before the first render, so a tab opened before a deploy recovers the first
   time it asks for a page file that has since been replaced. */
installChunkReload()

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)
